export default {
    getSessions: state => state.sessions,
}
